import { Icon } from '@buggy/shared'
import { FunctionComponent } from 'react'
import styled, { useTheme } from 'styled-components'
import { useIntl } from '@/i18n/hooks/use-intl'
import { exhaustiveCheck } from '@/utils/exhaustive-check'

type CollectionActionLabelType = 'add' | 'added' | 'cancel'

type CollectionActionLabelProps = {
  type: CollectionActionLabelType
}

const CollectionActionLabel: FunctionComponent<CollectionActionLabelProps> = ({
  type,
}) => {
  const theme = useTheme()
  const { formatMessage } = useIntl()

  switch (type) {
    case 'add':
      return (
        <LabelWrapper $color='unset' $hoverColor={theme.colors.brand.primary}>
          <IconWrapper>
            <Icon name='plus-square' />
          </IconWrapper>
          {formatMessage({
            id: 'general:add_btn',
          })}
        </LabelWrapper>
      )
    case 'added':
      return (
        <LabelWrapper $color={theme.colors.brand.primary}>
          <IconWrapper>
            <Icon name='check' />
          </IconWrapper>
          {formatMessage({
            id: 'general:added',
          })}
        </LabelWrapper>
      )
    case 'cancel':
      return (
        <LabelWrapper $color={theme.colors.brand.primary}>
          <IconWrapper>
            <Icon name='x' />
          </IconWrapper>
          {formatMessage({
            id: 'general:remove_from_collection',
          })}
        </LabelWrapper>
      )
    default:
      return exhaustiveCheck(type)
  }
}

const LabelWrapper = styled.div<{ $color: string; $hoverColor?: string }>`
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;

  color: ${(props): string => props.$color};
  transition: color 0.2s;

  &:hover {
    color: ${(props): string => props.$hoverColor ?? props.$color};
  }
`

const IconWrapper = styled.div`
  line-height: 1;
`

export default CollectionActionLabel
